export enum AppRoutePath {
  EventTracker = '/event/:id',
  LoginsWithLink = '/login/:token',
  Auth = '/auth',
  AuthWildcard = '/auth/*',
  AuthOtpSms = '/auth/otp/sms',
  AuthOtpPhoneCall = '/auth/otp/phone-call',
  AuthOtpSmsRelative = 'otp/sms',
  AuthOtpPhoneCallRelative = 'otp/phone-call',
  AuthWaitMessage = '/auth/wait-message',
  Home = '/home',
  RedeemPromocode = '/home/promocode/:code?',
  ReadyToUseOffers = '/home/ready-to-use',
  TotalAvailableRollbackOffers = '/home/total-available-rollback',
  PayAtPump = '/pay-at-pump',
  PayAtPumpSelectPump = '/pay-at-pump/select-pump/:storeId',
  PayAtPumpFuelingStatus = '/pay-at-pump/fueling-status/:transactionId',
  PayAtPumpReceipt = '/pay-at-pump/receipt/:transactionId',
  PayInside = '/pay-inside',
  Profile = '/profile',
  CommunicationPreferences = '/profile/communication',
  ProductInterests = '/profile/product-interests',
  ReferAFriend = '/profile/refer-a-friend',
  ReferAFriendProfileNested = 'refer-a-friend',
  ReferAFriendReceiver = '/r/:code',
  TransactionHistory = '/transactions',
  TransactionActivateDetails = '/transactions/loyalty/:transactionId',
  PointsChangeActivateDetailsNested = 'points-changes/:pointsChangeId',
  TransactionActivateDetailsNested = 'loyalty/:transactionId',
  TransactionMobileDetailsNested = 'mobile/:transactionId',
  Wallet = '/profile/wallet',
  PointExpiration = '/profile/point-expiration',
  StoreLocator = '/store-locator',
  StoreLocatorList = '/store-locator/list',
  StoreDetails = '/store-details/:storeId',
  DeleteAccount = '/delete-account',
  Devtools = '/devtools',
  IdentityVerification = 'identity-verification',
  AgeVerification = 'age-verification',
  CrashMe = '/crash-me',
  Surveys = '/surveys',
  Offers = '/offers',
  GuestSurvey = '/s/:id',
  OfferDetails = 'offers/:offerId',
  OfferDetailsAutoIdentify = 'offers/:offerId/auto-identify',
  /** Nested only under `${Offers}/*` — yields `/offers/:offerId`, not `/offers/offers/:offerId` */
  OffersTabOfferDetails = ':offerId',
  OffersTabOfferDetailsAutoIdentify = ':offerId/auto-identify',
  PreferredFuelGrade = '/profile/preferred-fuel-grade',
  SurveyDetails = '/surveys/:surveyUuid',
  OrderAhead = '/order-ahead',
  LocalOffersLocationSelector = '/home/local-offers-location-selector',
  SpireEnrollmentHome = 'spire/enroll',
  SpireEnrollment = '/profile/wallet/spire-enrollment',
}
